import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

// Auth
export const driverLogin = (badge_number, pin) =>
  api.post('/auth/driver/login', { badge_number, pin });

export const adminLogin = (username, password) =>
  api.post('/auth/admin/login', { username, password });

// Vehicles
export const getVehicles = () => api.get('/vehicles');
export const getAdminVehicles = () => api.get('/admin/vehicles');
export const createVehicle = (data) => api.post('/admin/vehicles', data);
export const deleteVehicle = (id) => api.delete(`/admin/vehicles/${id}`);

// Drivers
export const getDrivers = () => api.get('/admin/drivers');
export const createDriver = (data) => api.post('/admin/drivers', data);
export const updateDriver = (id, data) => api.put(`/admin/drivers/${id}`, data);
export const deleteDriver = (id) => api.delete(`/admin/drivers/${id}`);

// Checks
export const getChecklistItems = () => api.get('/checklist-items');
export const submitCheck = (data) => api.post('/checks', data);
export const getMyHistory = () => api.get('/checks/my-history');
export const getAllChecks = (params) => api.get('/admin/checks', { params });
export const getCheckDetail = (id) => api.get(`/admin/checks/${id}`);

// Stats
export const getStats = () => api.get('/admin/stats');

export default api;
